/* eslint-disable react-refresh/only-export-components -- schema builder co-located with component for cohesion */
import { useTranslation } from 'react-i18next';

const ITEMS = ['q1', 'q2', 'q3', 'q4', 'q5'] as const;

export function FaqAccordion() {
  const { t } = useTranslation();
  return (
    <section
      id="faq"
      aria-labelledby="faq-title"
      className="bg-paper"
    >
      <div className="mx-auto max-w-3xl px-6 py-16 sm:py-20">
        <h2
          id="faq-title"
          className="font-display text-3xl font-medium tracking-tight text-ink-900 sm:text-4xl"
        >
          {t('home.faq.title')}
        </h2>

        <dl className="mt-10 divide-y divide-ink-100 border-y border-ink-100">
          {ITEMS.map((key) => {
            const q = t(`home.faq.${key}`);
            const a = t(`home.faq.${key.replace('q', 'a')}`);
            return (
              <details
                key={key}
                className="group py-5"
                data-testid={`faq-${key}`}
              >
                <summary className="flex cursor-pointer list-none items-baseline justify-between gap-4 font-display text-lg font-medium text-ink-900 hover:text-terra-700">
                  <dt className="contents">
                    <span>{q}</span>
                  </dt>
                  <span
                    aria-hidden="true"
                    className="font-mono text-ink-400 transition-transform group-open:rotate-180"
                  >
                    ▾
                  </span>
                </summary>
                <dd className="mt-3 max-w-prose text-base leading-relaxed text-ink-700">
                  {a}
                </dd>
              </details>
            );
          })}
        </dl>
      </div>
    </section>
  );
}

/**
 * Returns JSON-LD FAQPage schema using the translated FAQ items.
 * Pass the rendered string to a `<script type="application/ld+json">` tag.
 */
export function buildFaqJsonLd(t: (k: string) => string): string {
  const mainEntity = ITEMS.map((key) => ({
    '@type': 'Question',
    name: t(`home.faq.${key}`),
    acceptedAnswer: {
      '@type': 'Answer',
      text: t(`home.faq.${key.replace('q', 'a')}`),
    },
  }));
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  });
}
